import { IHexPixelSize } from 'js/bubbleCore/view/types';
import { HexGridType } from 'js/bubbleCore/types';
import { isPointyTop } from 'js/bubbleCore/utils/isPointyTop';
import { getHexSize } from 'js/bubbleCore/utils/getHexSize';

export function getHexPixelSize(size: number, type: HexGridType): IHexPixelSize {
  const {width: hexWidth, height: hexHeight} = getHexSize(type);
  return {
    size,
    width: hexWidth * size,
    height: hexHeight * size,
    type,
  };
}
